var prc_collections_carousels = [];

document.addEventListener("DOMContentLoaded", function () {
    const carousels = document.querySelectorAll('.collections-carosel-parent');

    carousels.forEach(carousel => {
        prc_collections_carousels.push(carousel.parentElement.innerHTML);
        carousel.parentElement.remove();
    });

    let content_area = document.getElementById('MainContent').querySelector('.article');
    let html = content_area.innerHTML;
    // Regex to find the shortcode and its attributes
    let regex = new RegExp(`\\[prc-collections-carousel]`, 'g');
    let match;
    let loop_count = 0;

  
    // Replace each shortcode instance
    while ((match = regex.exec(html)) !== null) {

        if (loop_count >= prc_collections_carousels.length) break;

        html = html.replace(match[0], prc_collections_carousels[loop_count]);
        content_area.innerHTML = html;

        loop_count++;
    }

    const owl = $('.collections-carousel');

    owl.on('initialize.owl.carousel', event => {
        const carousel_parents = document.querySelectorAll('.collections-carosel-parent');
        carousel_parents.forEach(carousel => {
            carousel.classList.add('loaded');
        });
    });

    owl.owlCarousel({
        loop: true,
        margin: 10,
        responsiveClass: true,
        dots: false,
        responsive: {
            0: {
                items: 1,
                dots: false,
                nav: false
            },
            400: {
                items: 2,
                dots: false,
                nav: false
            },
            500: {
                items: 3,
                dots: false,
                nav: false
            },
            700: {
                items: 4,
                dots: false,
                nav: false
            }
        }
    });

});